import { getCSRFToken } from "./authService";

export const getEventData = async () => {
  const response = await fetch("/api/event", {
    method: "GET",
    credentials: "include",
  });
  const data = await response.json();
  return data;
};

export const startEvent = async (num_weeks, year) => {
  const token = await getCSRFToken();

  const form = new FormData();
  form.append("num_weeks", num_weeks);
  form.append("year", year);

  try {
    const response = await fetch(`/api/event/start-event`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
      body: form,
    });

    return response;
  } catch (error) {
    console.error("Error starting event:", error);
  }
};

export const cancelEvent = async () => {
  const token = await getCSRFToken();

  try {
    const response = await fetch(`/api/event/cancel-event`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
    });

    return response;
  } catch (error) {
    console.error("Error cancelling event:", error);
  }
};

export const endEvent = async () => {
  const token = await getCSRFToken();

  try {
    const response = await fetch(`/api/event/end-event`, {
      method: "PATCH",
      credentials: "include",
      headers: {
        "x-csrf-token": token,
      },
    });

    return response;
  } catch (error) {
    console.error("Error cancelling event:", error);
  }
};

export const adminLogin = async (data) => {
  const token = await getCSRFToken();

  const form = new FormData();
  form.append("code", data.password);

  const response = await fetch("/api/event/admin-login", {
    method: "POST",
    body: form,
    credentials: "include",
    headers: {
      "x-csrf-token": token,
    },
  });

  return response;
};

export const logout = async () => {
 const token = await getCSRFToken();

  const response = await fetch("/api/event/logout", {
    method: "POST",
    credentials: "include",
    headers: {
      "x-csrf-token": token,
    },
  });

  return response;
};
